export const parseAPIData=(data)=>{
    const parseAPIResponse = data && data?.map((item)=>({
                "fixture_id": item.fixture.id,
                "league_id": item.league.id,
                "league": {
                    "name": item.league.name,
                    "country": item.league.country,
                    "logo":    item.league.logo,
                    "flag": item.league.flag
                },
                "event_date": item.fixture.date,
                "event_timestamp": item.fixture.timestamp,
                "firstHalfStart": item.fixture.periods.first,
                "secondHalfStart": item.fixture.periods.second,
                "round": item.league.round,
                "status": item.fixture.status.long,
                "statusShort": item.fixture.status.short,
                "elapsed": item.fixture.status.elapsed,
                "venue": item.fixture.venue,
                "referee": item.fixture.referee,
                "homeTeam": {
                    "team_id": item.teams.home.id,
                    "team_name": item.teams.home.name,
                    "logo": item.teams.home.logo
                },
                "awayTeam": {
                    "team_id": item.teams.away.id,
                    "team_name": item.teams.away.name,
                    "logo": item.teams.away.logo
                },
                "goalsHomeTeam": item.goals.home,
                "goalsAwayTeam": item.goals.away,
                "score": {
                    ...item.score
                }
    }))
    return parseAPIResponse;

}
export const parseTeamDetailsAPIData=(data)=>{
    return {
            code: data?.team?.code,
            country: data?.team?.country,
            founded: data?.team?.founded,
            is_national: data?.team?.national,
            logo: data?.team?.logo,
            name: data.team?.name,
            team_id: data?.team?.id,
            venue_address: data?.venue?.address,
            venue_capacity: data?.venue?.capacity,
            venue_city: data?.venue?.city,
            venue_name: data?.venue?.name,
            venue_surface: data?.venue?.surface,

        }
}
export const parseTeamStatsAPI=(data)=>{
    console.log("parseTeamStatsAPI",data);
     return {
            "matchs": {
                "matchsPlayed": {
                    "home": data?.fixtures?.played?.home,
                    "away": data?.fixtures?.played?.away,
                    "total": data?.fixtures?.played?.total 
                },
                "wins": {
                    "home": data?.fixtures?.wins?.home,
                    "away": data?.fixtures?.wins?.away,
                    "total": data?.fixtures?.wins?.total,
                },
                "draws": {
                    "home": data?.fixtures?.draws?.home,
                    "away": data?.fixtures?.draws?.away,
                    "total": data?.fixtures?.draws?.total,
                },
                "loses": {
                    "home": data?.fixtures?.loses?.home,
                    "away": data?.fixtures?.loses?.away,
                    "total": data?.fixtures?.loses?.total,
                }
            },
            "goals": {
                "goalsFor": {
                    "home": data?.goals?.for?.total?.home,
                    "away": data?.goals?.for?.total?.away,
                    "total": data?.goals?.for?.total?.total,
                },
                "goalsAgainst": {
                    "home": data?.goals?.against?.total?.home,
                    "away": data?.goals?.against?.total?.away,
                    "total": data?.goals?.against?.total?.total,
                }
            },
            "goalsAvg": {
                "goalsFor": {
                    "home": data?.goals?.for?.average?.home,
                    "away": data?.goals?.for?.average?.away,
                    "total": data?.goals?.for?.average?.total,
                },
                "goalsAgainst": {
                    "home": data?.goals?.against?.average?.home,
                    "away": data?.goals?.against?.average?.away,
                    "total": data?.goals?.against?.average?.total,
                }
            }
        }

}
// European season: e.g. 2025 runs Aug 2025–May 2026. Include transfers from current and previous season.
function isTransferInRelevantSeasons(transferDateStr, currentSeasonStartYear) {
  if (!transferDateStr) return false;
  const year = parseInt(transferDateStr.substring(0, 4), 10);
  if (Number.isNaN(year)) return true;
  return year >= currentSeasonStartYear - 1 && year <= currentSeasonStartYear + 1;
}

export const parseTeamTransferAPIData=(data, currentSeasonStartYear)=>{
    const seasonYear = currentSeasonStartYear != null ? currentSeasonStartYear : new Date().getFullYear();
    const parseAPIResponse = data && data?.flatMap((item)=>(
        item && item.transfers && item.transfers.map((transfer)=>(
            {
                "player_id": item.player.id,
                "player_name": item.player.name,
                "transfer_date": transfer.date,
                "type": transfer.type,
                "team_in": transfer.teams?.in ? {
                    "team_id": transfer.teams.in.id,
                    "team_name": transfer.teams.in.name,
                } : {},
                "team_out": transfer.teams?.out ? {
                    "team_id": transfer.teams.out.id,
                    "team_name": transfer.teams.out.name,
                } : {},
                "lastUpdate": item.update
            }
        ))
    )) || [];
    return parseAPIResponse.filter((t) => isTransferInRelevantSeasons(t.transfer_date, seasonYear));
}
function _bestPlayerStat(statistics, preferredLeagueId) {
    if (!statistics || statistics.length === 0) return null;
    if (statistics.length === 1) return statistics[0];
    if (preferredLeagueId != null) {
        const match = statistics.find(s => s.league && s.league.id === preferredLeagueId);
        if (match) return match;
    }
    let best = statistics[0];
    let bestApps = (best.games && best.games.appearences) || 0;
    for (let i = 1; i < statistics.length; i++) {
        const apps = (statistics[i].games && statistics[i].games.appearences) || 0;
        if (apps > bestApps) {
            bestApps = apps;
            best = statistics[i];
        }
    }
    return best;
}

function _mapPlayerStats(item, playerStats) {
    return {
        "player_id": item.player.id,
        "player_name": item.player.name,
        "firstname": item.player.firstname,
        "lastname": item.player.lastname,
        "number": playerStats.games.number,
        "position": playerStats.games.position,
        "age": item.player.age,
        "birth_date": item.player?.birth?.date,
        "birth_place":  item.player?.birth?.place,
        "birth_country": item.player?.birth?.country,
        "nationality": item.player.nationality,
        "height": item.player.height,
        "weight": item.player.weight,
        "injured":item.player.injured,
        "rating": playerStats.games.rating,
        "team_id": playerStats.team.id,
        "team_name": playerStats.team.name,
        "league_id": playerStats.league.id,
        "league": playerStats.league.name,
        "season": playerStats.league.season,
        "captain": playerStats.games.captain,
        "shots": {
            "total": playerStats.shots.total,
            "on": playerStats.shots.on
        },
        "goals": {
            "total": playerStats.goals.total,
            "conceded": playerStats.goals.conceded,
            "assists":playerStats.goals.assists,
            "saves": playerStats.goals.saves,
        },
        "passes": {
            "total": playerStats.passes.total,
            "key": playerStats.passes.key,
            "accuracy": playerStats.passes.key,
        },
        "tackles": {
            "total": playerStats.tackles.total,
            "blocks": playerStats.tackles.blocks,
            "interceptions": playerStats.tackles.interceptions,
        },
        "duels": {
            "total": playerStats.duels.total,
            "won": playerStats.duels.won,
        },
        "dribbles": {
            "attempts": playerStats.dribbles.attempts,
            "success": playerStats.dribbles.success,
        },
        "fouls": {
            "drawn": playerStats.fouls.drawn,
            "committed": playerStats.fouls.committed
        },
        "cards": {
            "yellow": playerStats.cards.yellow,
            "yellowred": playerStats.cards.yellowred,
            "red": playerStats.cards.red
        },
        "penalty": {
            "won": playerStats.penalty.won,
            "commited": playerStats.penalty.committed,
            "success": playerStats.penalty.success,
            "missed": playerStats.penalty.missed,
            "saved": playerStats.penalty.saved
        },
        "games": {
            "appearences": playerStats.games.appearences,
            "minutes_played": playerStats.games.minutes,
            "lineups": playerStats.games.lineups,
        },
        "substitutes": {
            "in": playerStats.substitutes.in,
            "out": playerStats.substitutes.out,
            "bench": playerStats.substitutes.bench
        }
    };
}

export const parseTeamPlayersAPIData=(data, preferredLeagueId)=>{
    if (!data) return [];
    const seen = new Set();
    const result = [];
    for (const item of data) {
        if (!item || !item.statistics || !item.player) continue;
        const playerId = item.player.id;
        if (seen.has(playerId)) continue;
        seen.add(playerId);
        const bestStat = _bestPlayerStat(item.statistics, preferredLeagueId);
        if (bestStat) {
            result.push(_mapPlayerStats(item, bestStat));
        }
    }
    return result;
}



